export default function store() {
  return {
    lottery_state: {
      lottery: {}
    },
    confirm_state: {
      confirm_info: {}
    }
  };
}
